import moment from 'moment'
import styled from 'styled-components'
import PageHeader from '../../admin/components/PageHeader'
import { getPlayerNameFromCookie } from '../store/MetaStore'

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 4px;
`
const HeaderControls = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
  padding: 0 4px;
`

const YearSelect = styled.select`
  padding: 8px 12px;
  font-size: 0.95rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  background-color: white;
  cursor: pointer;
  outline: none;
  &:focus {
    border-color: #060;
  }
`


const EventItem = styled.div`
  padding: 15px;
  margin-bottom: 10px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eee;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }
`

const RoundResultsView = ({ events, onEventClick, selectedYear, availableYears, onYearChange }) => {
  const pageName = getPlayerNameFromCookie() || 'Round Results'

  return (
    <>
      <PageHeader pageName={pageName} backTo="/league/menu" />
      <Container>
        {availableYears && availableYears.length > 0 && (
          <HeaderControls>
            <YearSelect
              value={selectedYear}
              onChange={(e) => onYearChange(parseInt(e.target.value))}
            >
              {availableYears.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </YearSelect>
          </HeaderControls>
        )}
        <div className="animate-fade-in">
          {events.map(event => (
            <EventItem key={event.eventId} onClick={() => onEventClick(event.eventId)}>
              <div>
                <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                  {moment(event.eventDate).format('MMM D, YYYY')}
                </div>
                <div style={{ color: '#666', fontSize: '0.9rem' }}>
                  {event.courseName}
                </div>
              </div>
              <div style={{ color: '#060' }}>
                View Results ›
              </div>
            </EventItem>
          ))}
          {events.length === 0 && (
            <div style={{ textAlign: 'center', color: '#666', padding: '40px' }}>
              No events found.
            </div>
          )}
        </div>
      </Container>
    </>
  )
}

export default RoundResultsView
